<template>
    <Table :disabled="disabled">
        <template #thead>
            <tr class="text-white text-base">
                <td
                    v-for="(title, i) in columns"
                    :key="i"
                >
                    {{ title }}
                </td>

                <td v-if="disabled" />
            </tr>
        </template>
        <template #tbody>
            <tr
                v-for="item in data"
                :key="item.id"
                @click="toServicePage(item)"
            >
                <td class="pad:w-40 lg:w-44">
                    {{ item.fullPolicyNo }}
                </td>
                <td class="max-w-[18rem]">
                    {{ item.currencyText }}
                </td>
                <td class="min-w-[6.5rem]">
                    {{ item.name }}
                </td>
                <td class="min-w-[6.5rem]">
                    {{ formatToTwDateInterval(item.prePayDate,'/') }}
                </td>
                <td>
                    {{ item.formTxt }}
                </td>
                <td class="min-w-[6.5rem]">
                    <button
                        class="btn-text border-b-2 border-gray-400 leading-none"
                        @click.stop="getDetail(item)"
                    >
                        原約定帳號
                    </button>
                </td>
                <td
                    v-if="disabled"
                    class="p-0 w-[5.125rem]"
                >
                    <div class="bg-gray-400 text-sm text-white p-1.5">
                        {{ item.memo }}
                    </div>
                </td>
            </tr>
        </template>
    </Table>
</template>

<script>
import routeName from '@/router/constant.js';
import { useRoute } from 'vue-router';
import Table from '@/components/table/Table.vue';
import { formatToTwDateInterval } from '@/utils/is/dateUtils';

export default {
    name: 'TablePolicy',
    components: {
        Table
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        columns: {
            type: Array,
            required: true
        }
    },
    emits: ['toServicePage', 'getDetail'],
    setup(props, { emit }) {
        const route = useRoute();
        const toServicePage = (item) => {
            if (props.disabled) return;
            emit('toServicePage', item);
        };
        const getDetail = (item) => {
            emit('getDetail', item);
        };
        return {
            route,
            routeName,
            getDetail,
            toServicePage,
            formatToTwDateInterval
        };
    },
};
</script>
